// extracted by mini-css-extract-plugin
export default {"headerStyle":"TermHeader_headerStyle__vsfMR"};